const testInvokeKey = (e) => {
    const keyCode = e.keyCode || e.which
    return [13, 32].includes(keyCode)
}

const getClassName = (className, defaultClass) => {
    return (defaultClass === undefined || defaultClass) ? (className ? ("action " + className) : "action") : className
}

export default ({action, children, className, defaultClass, ...props}) => (
    <a href="#" 
        onClick={(e) => {e.preventDefault(); action(); return false}} 
        onKeyPress={(e) => testInvokeKey(e) ? action() : undefined}
        className={getClassName(className, defaultClass)}
        {...props}
    >{children}</a>
)
